<template>
  <div class="container">
    <div class="scroller">
      <div class="items items-main" :class="{activated: isActivated()}" ref="container">
        <div class="item" v-for="item, index in items" :key="item" :class="{active: isActive(index)}" @click="toggleActive(index)">
          <div class="image">
            <img :src="getImageUrl(item.image)">
          </div>
          <div class="text" :class="`text-${index}`">
            <h2 class="title">{{ item.name }}</h2>
            <p v-html="item.text"></p>
            <p>
              Klem Else
            </p>
            <button class="close"><img src="@/assets/close.svg" alt="Close"></button>
          </div>
        </div>
        <div class="items items-copy">
          <div class="item" v-for="item, index in items" :key="item" :class="{active: isActive(index)}" @click="toggleActive(index)">
            <div class="image">
              <img :src="getImageUrl(item.image)">
            </div>
            <div class="text" :class="`text-${index}`">
              <h2 class="title">{{ item.name }}</h2>
              <p v-html="item.text"></p>
              <p>
                Klem Else
              </p>
              <button class="close"><img src="@/assets/close.svg" alt="Close"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ExpanderMarquee',
    data() {
      return {
        active: null,
        lastAnimationTime: null,
        items: [
          {
            name: 'Anne-Kat. Hærland',
            text: 'Anne Kat er definisjonen på kul. Kompromissløs, kledelig trassig, og viktigst av alt: utrolig morsom. I mange år har hun levert intelligent og edgy humor som pirker borti sannheter mange av oss ikke tør å si høyt. Hun er en av tidenes største norske standupere, og nå har hun i tillegg blitt AI-ekspert. Tenk at hun kommer til meg. Gleder meg!',
            image: 'anne-kath.png',
          },
          {
            name: 'Christine Koht',
            text: 'Koko! Det sa hele Norge til Christine Kohts galskap, energi og boblende humør da hun kom feiende inn som et friskt pust på 00-tallet. Med serier som Koht i kommunen og kjempesuksessen Jan Johansen klamret hun seg fast i folkedypet for godt. Christine har vært gjennom sitt livs kamp de siste årene, men nå er hun frisk. Dødsfrisk!<br> Koht er en blomstrende nasjonalskatt.',
            image: 'christine-koht.png',
          },
          {
            name: 'Henriette Steenstrup',
            text: 'Et av mine favorittmennesker i hele verden, såpass ærlig skal jeg være. Hun er kvinnen bak den groveste karakteren på norske skjermer, Edel Hammersmark Gjervan, men også mesterhjernen bak den nydelig nyanserte Pørni. Henriette er mange ting, men lat er hun ikke. Komiker, skuespiller, manusforfatter, regissør, serieskaper og så videre og videre og videre. Geni-alarm.',
            image: 'henriette-steenstrup.png',
          },
          {
            name: 'Linn Skåber',
            text: 'Jeg elsker Linn Skåber. Så enkelt er det. Linn er en underholder som med største selvfølgelighet veksler uanstrengt mellom Nationaltheatret og Nytt på Nytt, og skriver kritikerroste poesibøker samtidig som hun viser sin geniale galskap i humorserien Hjerte til Hjerte. Linn!',
            image: 'linn-skaber.png',
          },
          {
            name: 'Leo Ajkic',
            text: 'Jeg digger Leo Ajkic. Men hvem gjør ikke det? Helt siden han begynte å rulle på r’ene på TV, har den rolige stemmen hans lært oss om livet på utsiden av samfunnet. Som programleder og dokumentarskaper har han vist oss at det ikke er så farlig å snakke om det farlige. Håper han liker store lenestoler!',
            image: 'leo-ajkic.png',
          },
          {
            name: 'Jon Almaas',
            text: 'Hva er Jon Almaas mest kjent for? Nytt på Nytt? Side om side?  71 grader nord? Alle mot Alle?<br> Personlig kjenner jeg ham som Norges beste besserwisser. Nå har han blitt bonde – og det gleder jeg meg veldig til å høre absolutt alle detaljene om. Neida. Men jeg gleder meg alltid til å henge med Jon!',
            image: 'jon-almaas.png',
          },
          {
            name: 'Morten Ramm',
            text: 'Morten Ramm liker ikke å bli kalt humormogul. Det burde han tenkt på før han ble en humormogul. Etter mange år som en av de aller, aller morsomste på TV, har han de siste årene valgt å bruke posisjonen sin til å lage et miljø for nye norske komikere, og løfte norsk humor opp og frem. Jeg har kjent Morten i mange år, og ingen er så varm og samtidig så kranglete og full av kødd som ham. Morten <3',
            image: 'morten-ramm.png',
          },
          {
            name: 'Pia Tjelta',
            text: 'Dronninga kommer! Få leverer så sterkt på teaterscenen, filmlerrettet og TV-skjermen. som Pia Tjelta. I tillegg til å sope inn skuespillerpriser i Norge og internasjonalt, er hun en suksessfull designer for sitt eget klesmerke. Litt kvalmt, sier du? Heldigvis er hun en rå og nydelig liten snik, som man alltid vil henge med på fest.',
            image: 'pia-tjelta.png',
          },
          {
            name: 'Espen Eckbo',
            text: 'Espen Eckbo er ikke så ofte på TV som seg selv. Men hans mange karakterer har vært en stor del av norsk humor i mange år.  Julekongen Asbjørn Brekke er én av dem.  Helt siden vi ble kjent med Espens komiske typer på talkshowene «Mandagsklubben» og «I kveld med Thomas Giertsen» har han vært vår store karakterkonge. Espen tar humor på alvor. Og det skal vi være glade for!',
            image: 'espen-eckbo.png',
          },
          {
            name: 'Bård Tufte Johansen',
            text: 'Finnes det noen som er mer naturlig morsom enn Bård? Tror ikke det. Sammen med Harald Eia revolusjonerte han norsk humor på 90-tallet, og siden har han aldri sluttet å få oss til å le. Hver fredag loser han oss stødig inn i helga med Nytt på Nytt, og de siste årene har han på rekordtid etablert seg som en av våre mestselgende standup-komikere. Spent!',
            image: 'bard-johansen.png',
          },
        ],
      }
    },
    methods: {
      getImageUrl(image) {
        return require(`@/assets/people/${image}`)
      },
      toggleActive(index) {
        if (this.active === index) {
          this.deactivate()
        } else {
          let anim = document.getAnimations()[0]
          this.lastAnimationTime = anim.currentTime
          this.active = index
          let el = this.$refs.container
          let offset = index * 8 - 4
          if (index == 0)
            offset = 96
          el.style.animation = `none`
          el.style.transform = `translate3d(-${offset}%, 0, 0)`
        }
      },
      deactivate() {
        this.active = null
        let el = this.$refs.container
        el.style.transform = null
        el.style.animation = null
        if (this.lastAnimationTime !== null)
          document.getAnimations()[0].currentTime = this.lastAnimationTime
      },
      isActive(id) {
        return id === this.active
      },
      isActivated() {
        return (this.active !== null)
      }
    },
    // mounted() {
    //   console.log(document.getAnimations())
    // }
  }
</script>

<style scoped lang="scss">
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';

  @keyframes marquee {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      transform: translate3d(-100%, 0, 0);
    }
  }

  .scroll-container {
    position: relative;
  }
  .scroller {
    overflow: hidden;
    @include m {
      padding: 5vw 0;
    }
  }
  .items {
    // position: relative;
    display: inline-flex;
    justify-content: space-between;
    align-items: stretch;
  }
  .items-main {
    will-change: transform;
    animation: marquee 20s linear infinite normal forwards;
    // &.activated {
    //   animation-play-state: paused;
    // }
  }
  .items-copy {
    position: absolute;
    left: 0;
    top: 0;
    transform: translate3d(100%, 0, 0);
  }
  .item {
    position: relative;
    display: flex;
    .image {
      flex-shrink: 0;
      width: 27vw;
      overflow: hidden;
      cursor: pointer;
      @include d {
        width: 14.5rem;
      }
      img {
        transition: transform .3s;
      }
      &:hover {
        img {
          transform: scale(1.05);
        }
      }
    }
    .text {
      position: relative;
      display: none;
      width: 50vw;
      padding: 1rem .5rem 1rem 1vw;
      background: rgba(208, 152, 151, 0.50);
      @include d {
        width: 40.25rem;
        padding: 3rem 5.25rem .5rem;
      }
      .title {
        margin-bottom: .5rem;
        padding-right: 1.5rem;
        font-size: 1rem;
        @include d {
          margin-bottom: 1.375rem;
          padding-right: 0;
          font-size: 2rem;
        }
      }
      p {
        font-family: Roboto, sans-serif;
        font-size: .75rem;
        @include d {
          font-size: 1.25rem;
        }
      }
      p + p {
        margin-top: 1.25rem;
      }
      .close {
        position: absolute;
        right: .5rem;
        top: .5rem;
        width: 2rem;
        opacity: .5;
        @include d {
          right: .5rem;
          top: 1rem;
          width: 3.5rem;
          &:hover {
            opacity: 1;
          }
        }
      }
    }
    .text-1,
    .text-4,
    .text-8 {
      background: rgba(203, 167, 99, 0.50);
    }
    .text-2,
    .text-5,
    .text-7,
    .text-9 {
      background: rgba(169, 181, 205, 0.50);
    }
    &.active {
      @include m {
        position: relative;
        z-index: 10;
        transform: scale(1.1);
        background: rgb(208, 152, 151);
        &:nth-child(2),
        &:nth-child(5),
        &:nth-child(9) {
          background: rgb(203, 167, 99);
        }
        &:nth-child(3),
        &:nth-child(6),
        &:nth-child(8),
        &:nth-child(10) {
          background: rgb(169, 181, 205);
        }
      }
      .text {
        display: block;
      }
      .image {
        &:hover {
          img {
            transform: none;
          }
        }
        @include m {
          width: 15vw;
          padding-left: 1vw;
        }
      }
    }
    // &:hover {
    //   .image {
    //     img {
    //       transform: scale(1.05);
    //     }
    //   }
    // }
  }

</style>

